var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "content-page", attrs: { id: "actors-index" } },
    [
      _c(
        "segment",
        { attrs: { title: _vm.$t("actors.search.title") } },
        [
          _c("actor-query-options", {
            ref: "queryOptions",
            attrs: { mode: "index", autofocus: true },
            on: { search: _vm.onSearch },
          }),
        ],
        1
      ),
      _vm.promotionPageReached
        ? _c("promotion-no-results-call-to-action", {
            staticClass: "is-parent",
            attrs: { "anonymous-only": true },
            scopedSlots: _vm._u(
              [
                {
                  key: "bubble-title",
                  fn: function () {
                    return [
                      _c("h3", { staticClass: "bubble-title" }, [
                        _vm._v(_vm._s(_vm.$t("actors.loginToFindMore"))),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4029093941
            ),
          })
        : _vm._e(),
      _c("actor-highlights", {
        ref: "actorHighlights",
        attrs: {
          title: _vm.$t("actors.prominent"),
          items: _vm.actorsHighlights,
          "show-artworks": false,
        },
        on: {
          error: function ($event) {
            _vm.error = $event
          },
        },
      }),
      _vm.actors.length
        ? _c(
            "segment",
            {
              attrs: {
                "class-name": "actors-others",
                title: _vm.$t("actors.others"),
              },
            },
            [
              _c(
                "div",
                { staticClass: "columns other-actors" },
                [
                  !_vm.readyAllActors && !_vm.error
                    ? _c("loading-spinner")
                    : _vm._e(),
                  _c("slick-slides", {
                    attrs: { options: _vm.slickOptions1, items: _vm.actors },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "slide-card",
                          fn: function (slotScope) {
                            return [
                              _c("actor-card", {
                                attrs: {
                                  role: "article",
                                  item: slotScope.item,
                                  "link-to": true,
                                  "image-as-background": false,
                                  social: false,
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2709724458
                    ),
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.heroImages.length && _vm.readyAllActors
        ? _c("artwork-spotlights", {
            attrs: {
              title: _vm.$t("actors.prominent"),
              images: _vm.heroImages,
              "card-component": "artwork-card",
            },
          })
        : _vm._e(),
      !_vm.ready && !_vm.error ? _c("loading-spinner") : _vm._e(),
      _vm.error
        ? _c("errors-message", { attrs: { error: _vm.error } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }